// extracted by mini-css-extract-plugin
export default {"badge":"style_badge__5lhlg"};